if (!customElements.get('culture-time-line-swiper')) {
    customElements.define(
        'culture-time-line-swiper',
        class CultureTimeLineSwiper extends HTMLElement {
            connectedCallback() {
                if (this._initialized) return;
                this._initialized = true;
                this._mq = window.matchMedia('(max-width: 767.98px)');
                this._onMqChange = this._onMqChange.bind(this);
                if (this._mq.addEventListener) {
                    this._mq.addEventListener('change', this._onMqChange);
                } else {
                    this._mq.addListener(this._onMqChange);
                }
                requestAnimationFrame(() => this.initSlider());
            }

            disconnectedCallback() {
                this._initialized = false;
                if (this._mq && this._onMqChange) {
                    if (this._mq.removeEventListener) {
                        this._mq.removeEventListener('change', this._onMqChange);
                    } else {
                        this._mq.removeListener(this._onMqChange);
                    }
                }
                this._mq = null;
                this._onMqChange = null;
                if (this._slider?.destroy) {
                    this._slider.destroy(true, true);
                }
                this._slider = null;
            }

            _onMqChange() {
                if (!this._initialized || !this.isConnected) return;
                requestAnimationFrame(() => this.initSlider());
            }

            initSlider() {
                const prevIndex = this._slider && !this._slider.destroyed ? this._slider.activeIndex : 0;

                if (this._slider?.destroy) {
                    this._slider.destroy(true, true);
                    this._slider = null;
                }

                const isMobile = this._mq ? this._mq.matches : window.matchMedia('(max-width: 767.98px)').matches;
                const S = window.FoxTheme.Swiper;

                const baseOptions = {
                    slidesPerView: 1,
                    spaceBetween: 0,
                    loop: false,
                    grabCursor: true,
                    allowTouchMove: true,
                    navigation: {
                        nextEl: this.querySelector('.swiper-button-next'),
                        prevEl: this.querySelector('.swiper-button-prev'),
                    },
                };

                let options;
                let additionModules;

                if (isMobile) {
                    additionModules = [S.EffectFade];
                    options = {
                        ...baseOptions,
                        autoHeight: true,
                        effect: 'fade',
                        fadeEffect: {
                            crossFade: true,
                        },
                    };
                } else {
                    // 桌面端单独用 slide，避免与 EffectFade 在 breakpoints 里切换导致无法滑动/点击失效
                    additionModules = [];
                    options = {
                        ...baseOptions,
                        autoHeight: false,
                        effect: 'slide',
                    };
                }

                const carousel = new window.FoxTheme.Carousel(this, options, additionModules);
                carousel.init();
                this._slider = carousel.slider;

                if (prevIndex > 0 && this._slider && !this._slider.destroyed) {
                    this._slider.slideTo(prevIndex, 0);
                }
            }
        }
    );
}
